const translation = (locale) => {
  return {
    locale: locale,
    fallbackLocale: "en",
    messages: {
      en: {
        copy: {
          resourcesPage: {
            title: "Resources",
            filterBy: "Filter by",
            filterSection: {
              sessions: "Sessions",
              day: "Day { i }: ",
              all: "All",
              'gic-1-sessions': "GIC 1 Sessions",
              'gic-2-sessions': "GIC 2 Sessions"
            },
            searchContent: {
              searchingStringText: `Search results for "{searchTerm}"`,
              noResourcesSearchText: `Your search for "{searchTerm}" didn't return any results.`,
              noOfResourcesFound: `{count} resources found`,
            },
            videoPage: {
              videoChapters: "Video Chapters",
              yellowTag: {
                exclusive: "Exclusive",
                audioOnly: "Audio only",
              },
              shareButton: "Share",
            },
            description:
              "Welcome to your one-stop hub for all GenerationS & StronG Church resources. Use these sermons, videos, tools to grow your church Younger & Stronger.",
            searchBar: "Search",
            resourceSearch: {
              bookSection: {
                header: "Book",
              },
              quotesSection: {
                header: "Quotes",
              },
              suggestionSection: {
                header: "You may be interested in...",
              },
            },
            backToTopSection: {
              otherContentText: "Interested in other resources?",
              backToTop: "Back to top",
            },
          },
          masterLayout: {
            logoutPopup: {
              message: "Do you want to log out?",
              continue: "Continue",
              cancel: "Cancel",
            },
            filterModal: {
              resetFilters: "Reset",
              applyFilters: "Apply filters",
            },
          },
        },
      },
    },
  };
};

export default translation;
